import { Link, useLocation } from 'react-router-dom';

const TAB_ITEMS = [
  { label: '首页', to: '/', match: '/', icon: 'ri-home-5-line', iconActive: 'ri-home-5-fill' },
  { label: '分类', to: '/category/movie', match: '/category', icon: 'ri-grid-line', iconActive: 'ri-grid-fill' },
  { label: '搜索', to: '/search', match: '/search', icon: 'ri-search-line', iconActive: 'ri-search-line' },
  { label: '资讯', to: '/news', match: '/news', icon: 'ri-newspaper-line', iconActive: 'ri-newspaper-fill' },
  { label: '关于', to: '/about', match: '/about', icon: 'ri-information-line', iconActive: 'ri-information-fill' },
];

export default function MobileTabBar() {
  const location = useLocation();

  return (
    <nav
      aria-label="移动端底部导航"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden"
    >
      <ul className="flex items-stretch">
        {TAB_ITEMS.map((item) => {
          const active =
            item.match === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.match);
          return (
            <li key={item.label} className="flex-1">
              <Link
                to={item.to}
                className={`flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] ${
                  active ? 'text-primary-700' : 'text-foreground-500'
                }`}
              >
                <i className={`${active ? item.iconActive : item.icon} text-xl leading-none`} />
                <span className={active ? 'font-semibold' : ''}>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}